<template>
  <b-container
    fluid="md"
    class="square-payment-payment-transaction-not-found-error"
  >
    <b-row>
      <b-col>
        <div class="title pb-4">
          <span class="icon-container">
            <font-awesome-icon
              icon="triangle-exclamation"
              size="2x"
              class="icon"
              fixed-width
              color="red"
            />
          </span>
          <span class="h3 pr-4">
            Transaction not found
          </span>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="error-type">
          <p>Transaction request could not be located.</p>
          <p>Please contact the site administrator for assistance resolving this issue.</p>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'square-payment-transaction-not-found-error',
  props: {
    error: {
      type: [Error, Object],
      required: true
    }
  }
}
</script>

<style>

</style>
